// extracted by mini-css-extract-plugin
export var actionText = "_pz-4";
export var container = "_pz-0";
export var leftSection = "_pz-1";
export var rightSection = "_pz-2";
export var settingsButton = "_pz-6";
export var settingsIcon = "_pz-7";
export var shortcut = "_pz-5";
export var shortcutGroup = "_pz-3";